<template>
  <div class="detections-grid-row species-latest-detections-row" :class="{ active: active }">
    <div>
      <time class="timestamp">
        {{ formatDate(detection.timestamp) }}
        <small class="text-muted">{{ formatTime(detection.timestamp) }}</small>
      </time>
    </div>
    <div class="station-name">
      <img v-if="detection.station" :src="stationIconUrl(detection.station.type)" class="station-icon" />
      <span v-if="detection.station" v-html="stationName"></span>
    </div>
    <div class="text-center">
      <DetectionScore class="inline" :detection="detection" tooltipPlacement="left" />
    </div>
  </div>
</template>

<script>
import DetectionScore from 'components/DetectionScore'

import FormatTimeMixin from 'mixins/FormatTime'

import { stationIcon } from 'lib/station'

export default {
  mixins: [FormatTimeMixin],

  props: {
    detection: {
      type: Object,
      required: true
    },

    active: {
      type: Boolean,
      default: false
    },

    timestampMode: {
      type: String,
      default: 'Station'
    }
  },

  methods: {
    stationIcon,

    stationIconUrl (type) {
      return require(`images/markers/${this.stationIcon(type)}.png`)
    }
  },

  computed: {
    defaultDateFormat () {
      if (window.outerWidth >= 768) {
        return 'Do MMM YYYY'
      } else {
        return 'l'
      }
    },

    defaultTimeFormat () {
      if (this.timeFormat == '24h') {
        return 'HH:mm:ss'
      } else {
        return 'h:mm:ss A'
      }
    },

    stationName () {
      return this.detection.station.name.replace(/\//, '/<wbr>')
    }
  },

  components: {
    DetectionScore
  }
}
</script>
